import firebase from "firebase";

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyAhoThu-nnoIpxzyZfVG54she8qPoXQIdY",
  authDomain: "dengue-eaa96.firebaseapp.com",
  databaseUrl: "https://dengue-eaa96.firebaseio.com",
  projectId: "dengue-eaa96",
  storageBucket: "dengue-eaa96.appspot.com",
  messagingSenderId: "405160957726"
});

const db = firebaseApp.firestore();

export { db };